import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate } from "react-router-dom";
const FlowCard = (props: any) => {
  const navigate = useNavigate();
  // The step is done once the case has an activity of this card's type.
  const done =
    Array.isArray(props.activity) &&
    props.activity.some(
      (activityItem: any) => activityItem["activity_type"] === props.type,
    );
  const getBackgroundImage = () =>
    done
      ? `url(${process.env.REACT_APP_API_DOMAIN}/images/gray_check.png)`
      : "";

  const progressChip = props.progress && (
    <Chip
      label={`${props.progress.filled} / ${props.progress.total}`}
      size="small"
      sx={{
        fontSize: "0.7rem",
        bgcolor:
          props.progress.filled === 0
            ? "#bdbdbd"
            : props.progress.filled === props.progress.total
            ? "#4caf50"
            : "#f59e0b",
        color: "#fff",
        fontWeight: 600,
      }}
    />
  );

  return (
    <Box
      sx={{
        boxShadow:
          "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);",
        textAlign: "center",
        alignItems: "center",
        cursor: "pointer",
        backgroundColor: props.disable ? "#cdcdcd" : "",
        borderRadius: "10px",
        // Compact cards (tablet and phone) are the title bar and one status
        // line: no subtitle, no check image.
        ...(!props.compact && {
          minHeight: "180px",
          backgroundImage: getBackgroundImage(),
          backgroundSize: "50px auto",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center 110px",
        }),
      }}
      onClick={() => {
        if (!props.disable) {
          props.setCardOpen(true);
          props.setOpenCardTitle(props.title);
          if (props.navigateUrl) {
            navigate(props.navigateUrl);
          }
        }
      }}
    >
      <div
        className={`${props.disable ? "bg-[#8a8a8aff]" : "bg-[#0f95b3]"} ${
          props.compact ? "min-h-10" : "h-10"
        } rounded-t-[10px] flex items-center justify-center`}
      >
        <h3
          className={`text-xs font-bold text-center ${
            props.compact ? "mx-2 my-1" : "m-4"
          }`}
          style={{ color: "white" }}
        >
          {props.displayTitle}
        </h3>
      </div>
      {props.compact ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            minHeight: 36,
            px: 1,
          }}
        >
          {done && (
            <Typography
              variant="body2"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.5,
                color: "success.main",
                fontWeight: 500,
              }}
            >
              <CheckIcon fontSize="small" />
              Done
            </Typography>
          )}
          {progressChip}
        </Box>
      ) : (
        <>
          <div
            className="text-xs text-left m-2"
            style={{ textAlign: "center" }}
          >
            {props.subtitle}
          </div>
          {props.progress && (
            <Box sx={{ display: "flex", justifyContent: "center", pb: 1 }}>
              {progressChip}
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default FlowCard;
